import { useEffect } from 'react';
import { SITE_URL, SITE_NAME } from '../utils/seo';

const DEFAULT_IMAGE = `${SITE_URL}/logo-horizontal-color.png`;

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function upsertJsonLd(id, data) {
  let el = document.head.querySelector(`script#${id}`);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(Array.isArray(data) ? data : [data]);
}

/**
 * Met à jour le <title>, la meta description, le canonical et les balises
 * Open Graph / Twitter Card pour la page courante. Le SPA n'a qu'un seul
 * index.html : ce composant est ce qui permet à chaque route d'avoir des
 * balises distinctes côté client (SSR/prerender non utilisé ici).
 */
export default function Seo({ title, description, path = '/', image, noindex = false, jsonLd = null }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Sénégal`;
    const url = `${SITE_URL}${path}`;
    const img = image ? (image.startsWith('http') ? image : `${SITE_URL}${image}`) : DEFAULT_IMAGE;

    document.title = fullTitle;
    upsertMeta('name', 'description', description);
    upsertLink('canonical', url);

    upsertMeta('property', 'og:site_name', SITE_NAME);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', img);

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', img);

    upsertMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow');

    upsertJsonLd('seo-jsonld-page', jsonLd);
    return () => upsertJsonLd('seo-jsonld-page', null);
  }, [title, description, path, image, noindex, jsonLd]);

  return null;
}
